import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import api from '../api/api';
import { setUserDetails } from '../redux/userSlice';
import { useDispatch } from 'react-redux';
import FieldLogin from './FieldLogin'
import Footer from './Footer';
import { sidebarListItems } from '../utils/sidebarList';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
const [showFieldLogin, setShowFieldLogin] = useState(false);

  const handleFieldLogin = () => {
    setShowFieldLogin(true);
  };

  const handleCloseFieldLogin = () => {
    setShowFieldLogin(false);
  };
const dispatch=useDispatch()
  const submitLogin = async () => {
    if (!username) {
      setError('Username is required.');
      return;
    }
    if (!password) {
      setError('Password is required.');
      return;
    }

    setLoading(true); // Disable button and change text
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    try {
      const response = await api.post(`/auth/token`, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      if (response.status === 200) {
        console.log(response)
        sessionStorage.setItem('accessToken', response?.access_token);
        sessionStorage.setItem('role', response.data[0]?.user_roles?.role);
        sessionStorage.setItem('userid', response?.id);



        
        dispatch(setUserDetails(response?.data[0]))
        // navigate('/dashboard');
        console.log(response.data[0]?.role==1)
        sidebarListItems(null)
        if(response.data[0]?.role==1){
     navigate('/home');
        }else if(response.data[0]?.role==2){
  navigate('/dashboard');
        }else{
 navigate('/home');

        }
           
      }
       else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (error) {
      setError('Login failed. Please check your details and try again.');
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <div className="flex flex-grow items-center justify-center px-4">
        <div className="bg-white p-6 md:p-8 rounded-lg shadow-custom-dark w-full max-w-[660px] h-auto flex flex-col justify-center">
          <div className="flex justify-center my-8">
            <img 
              src="https://ai.brainymed.com/ntact/public//assets/images/logo.png?id=2025030410" 
              alt="Logo" 
              className="w-50 h-auto"
            />
          </div>
          <div className="text-md  font-inter mb-1 text-start text-[#6c757d]">Enter Username</div>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError('');
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <div className="text-start text-[#6c757d] text-md  font-inter mb-1">Enter Password</div>
          <div className="relative w-full">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              className="w-full px-3  py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 pr-12"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
            >
              {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </button>
          </div>

          {error && <div className="text-red-600 text-sm mt-2 mb-2">{error}</div>}

          <button 
            onClick={submitLogin}
            disabled={loading}
            className={`w-full px-3 py-2 mt-8 text-white rounded-md text-md font-inter transition duration-300  ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#145388] hover:bg-[#0f3a66]'
            }`}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div className="mt-3 text-right">
            {/* <button 
             onClick={handleFieldLogin}
            className="text-[#1a66a3]  text-sm font-inter hover:underline">
              Field Login
            </button> */}
            {showFieldLogin && (
        <div className="fixed inset-0 z-50">
          <FieldLogin onClose={handleCloseFieldLogin} />
        </div>
      )}
          </div>
        </div>
      </div>
      <Footer/>
{/* 
      <footer className="text-center p-4 text-sm text-gray-600">
        © <span className='font-semibold'>Brainymed </span>{currentYear} All rights reserved.
      </footer> */}
    </div>
  );
};

export default Login;
